(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bv-signup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit',event=>{
 const form=event.target.closest('[data-bv-email-signup]');if(!form)return;
 event.preventDefault();if(!form.reportValidity())return;
 const email=form.elements.email.value.trim(),formId=form.dataset.bvEmailSignup;
 window._klOnsite=window._klOnsite||[];window._klOnsite.push(['openForm',formId]);
 const fill=()=>{
  const inputs=[...document.querySelectorAll('input[type="email"]')].filter(input=>!input.closest('[data-bv-email-signup]')&&input.closest('.klaviyo-form')&&input.getClientRects().length);
  const input=inputs[0];if(!input)return false;
  const setter=Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set;
  setter.call(input,email);input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));
  return true;
 };
 if(fill())return;const observer=new MutationObserver(()=>{if(fill())observer.disconnect();});observer.observe(document.body,{childList:true,subtree:true});setTimeout(()=>observer.disconnect(),10000);
});

  } catch(e) { console.error(e); }
})();
})();
